import React from 'react';

export const DashboardComponent = props => {
		return (
      <div id="dashboard">{props.children}</div>
		);
}



// WEBPACK FOOTER //
// ./src/components/Dashboard/DashboardComponent.js